/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_SortInputs */

const en_btn_sort = /** @type {(inputs: Btn_SortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort`)
};

const ko_btn_sort = /** @type {(inputs: Btn_SortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬`)
};

const ja_btn_sort = /** @type {(inputs: Btn_SortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソート`)
};

/**
* | output |
* | --- |
* | "Sort" |
*
* @param {Btn_SortInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const btn_sort = /** @type {((inputs?: Btn_SortInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_SortInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_sort(inputs)
	if (locale === "ko") return ko_btn_sort(inputs)
	return ja_btn_sort(inputs)
});